import { configureStore } from '@reduxjs/toolkit';
import cringeReducer from '../pages/cringe/cringeSlice';
import roadiesReducer from '../pages/roadies/roadiesSlice';

export const store = configureStore({
  reducer: {
    cringe: cringeReducer,
    roadies: roadiesReducer
  }
});
